/**
 * Сума прописом українською (гривні та копійки).
 * Приклад: 60873 → "Шістдесят тисяч вісімсот сімдесят три гривні 00 копійок"
 */

const ONES_M = ['', 'один', 'два', 'три', 'чотири', 'п\'ять', 'шість', 'сім', 'вісім', 'дев\'ять'];
const ONES_F = ['', 'одна', 'дві', 'три', 'чотири', 'п\'ять', 'шість', 'сім', 'вісім', 'дев\'ять'];
const TEENS = [
  'десять', 'одинадцять', 'дванадцять', 'тринадцять', 'чотирнадцять',
  'п\'ятнадцять', 'шістнадцять', 'сімнадцять', 'вісімнадцять', 'дев\'ятнадцять',
];
const TENS = [
  '', '', 'двадцять', 'тридцять', 'сорок', 'п\'ятдесят',
  'шістдесят', 'сімдесят', 'вісімдесят', 'дев\'яносто',
];
const HUNDREDS = [
  '', 'сто', 'двісті', 'триста', 'чотириста', 'п\'ятсот',
  'шістсот', 'сімсот', 'вісімсот', 'дев\'ятсот',
];

const pluralize = (n, one, few, many) => {
  const n10 = n % 10;
  const n100 = n % 100;
  if (n10 === 1 && n100 !== 11) return one;
  if (n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14)) return few;
  return many;
};

const tripletToWords = (n, feminine) => {
  const ones = feminine ? ONES_F : ONES_M;
  const parts = [];
  const h = Math.floor(n / 100);
  const t = Math.floor((n % 100) / 10);
  const o = n % 10;
  if (h) parts.push(HUNDREDS[h]);
  if (t === 1) {
    parts.push(TEENS[o]);
  } else {
    if (t) parts.push(TENS[t]);
    if (o) parts.push(ones[o]);
  }
  return parts.join(' ');
};

const capitalize = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

/**
 * @param {number} amount
 * @returns {string}
 */
export const amountToUkrainianWords = (amount) => {
  const num = Number(amount);
  if (!Number.isFinite(num) || num < 0) return '';

  const totalKop = Math.round(num * 100);
  const hryvnias = Math.floor(totalKop / 100);
  const kopiyky = totalKop % 100;

  if (hryvnias === 0) {
    const kopWord = pluralize(kopiyky, 'копійка', 'копійки', 'копійок');
    const kopWords = tripletToWords(kopiyky, true) || 'нуль';
    return capitalize(`${kopWords} ${kopWord}`.trim());
  }

  const millions = Math.floor(hryvnias / 1_000_000);
  const thousands = Math.floor((hryvnias % 1_000_000) / 1000);
  const rest = hryvnias % 1000;

  const parts = [];
  if (millions) {
    parts.push(tripletToWords(millions, false));
    parts.push(pluralize(millions, 'мільйон', 'мільйони', 'мільйонів'));
  }
  if (thousands) {
    parts.push(tripletToWords(thousands, true));
    parts.push(pluralize(thousands, 'тисяча', 'тисячі', 'тисяч'));
  }
  if (rest || (!millions && !thousands)) {
    // «гривня» — жіночий рід: одна/дві гривні
    parts.push(tripletToWords(rest, true) || (hryvnias === 0 ? 'нуль' : ''));
  }

  const hryvniaWord = pluralize(hryvnias, 'гривня', 'гривні', 'гривень');
  const kopStr = String(kopiyky).padStart(2, '0');
  const kopWord = pluralize(kopiyky, 'копійка', 'копійки', 'копійок');

  return capitalize(`${parts.filter(Boolean).join(' ')} ${hryvniaWord} ${kopStr} ${kopWord}`.replace(/\s+/g, ' ').trim());
};
